/*
 *   Copyright (c) 2021
 *   All rights reserved.
 */
import http from 'src/services/http';
import { ethers } from 'ethers';
import Web3 from 'web3';
import { ENVS } from 'src/configs/Configs.env';
import contractLockTier from 'src/contracts/LockTierV2.json';

const provideUrl = ENVS.REACT_APP_IS_MAINNET
    ? 'https://bsc-dataseed.binance.org/'
    : 'https://data-seed-prebsc-1-s2.binance.org:8545/';

export const getUpComing = async () => {
    return http.get('/pool-approved/?filter[listing_status]=1&filter[pool_type]=1');
};
export const getDataReport = async () => {
    let urlGet = `${ENVS.REACT_APP_BASE_API}report/summary`;
    return http.get(urlGet);
};

export const getUniqueKYCs = () => {
    const apiURL = 'https://kyc.blockpass.org/kyc/1.0/connect/infinitelaunchDotIo/applicants/approved';
    const parameters = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'c673412f148cf17f70838b8f5a751466',
        },
    };
    return fetch(apiURL, parameters)
        .then((response) => response.json())
        .then((json) => json?.data?.total);
};

export const getTotalBalanceLocked = async (contractAddr: string) => {
    const contractABI: any = contractLockTier;
    const web3 = new Web3(new Web3.providers.HttpProvider(provideUrl));
    const contract: any = new web3.eth.Contract(contractABI, contractAddr);
    try {
        const result = await contract.methods.totalBalanceLocked().call();
        return ethers.utils.formatEther(result);
    } catch (error) {
        console.log('totalBalanceLocked: ', error);
        throw error;
    }
};
